
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GenericReferenceContainerComponent } from './containers/GenericReference/GenericReference.component';

const routes: Routes = [
	{ path: 'stakeholderreference', component: GenericReferenceContainerComponent }
	
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ]
})
export class StakeholderReferenceRoutingModule {}